import * as React from "react";
import { FormikErrors, Formik } from "formik";
import { IUpdatePassword } from "../../vm";
import { withToastContext, IToast } from "../common/ToastProvider";
import {
  Label,
  MessageBar,
  MessageBarType,
  PrimaryButton,
  TextField,
} from "office-ui-fabric-react";
import "../auth/login.css";
import {
  updateAdminPassword,
  updateTeamRolePassword,
  lastPasswordUpdatedTime,
} from "../../services/auth/AuthService";
import { withRouter, RouteComponentProps } from "react-router";
import PasswordPolicy from "../common/PasswordPolicy";
import { isValidPassword, parseJwt } from "../../services/UtilService";
import { Loading } from "../../services/Loading";
import "../auth/login.css";

export interface ChangePasswordPageProps extends IToast, RouteComponentProps {}

export interface ChangePasswordPageState {
  updatePassword: IUpdatePassword;
  errorMsg?: string;
  showPasswordUpdatedRecently: boolean;
  isAdmin: boolean;
  isLoading: boolean;
}

class ChangePasswordPage extends React.Component<
  ChangePasswordPageProps,
  ChangePasswordPageState
> {
  constructor(props: ChangePasswordPageProps) {
    super(props);
    this.state = {
      updatePassword: {
        newPassword: "",
        oldPassword: "",
      },
      showPasswordUpdatedRecently: false,
      isAdmin: false,
      isLoading: false,
    };
  }
  componentDidMount = async () => {
    this.setState({ isLoading: true });
    const tokenData = parseJwt();
    if (tokenData.isAdmin === true) {
      this.setState({ isAdmin: true });
    }
    const lastPassword = await lastPasswordUpdatedTime();
    if (lastPassword && lastPassword.success) {
      if (
        lastPassword.data.date &&
        new Date(lastPassword.data.date).getTime() >
          new Date().getTime() - 24 * 60 * 60 * 1000
      ) {
        this.setState({ showPasswordUpdatedRecently: true });
      }
    }
    this.setState({ isLoading: false });
  };
  render() {
    return (
      <React.Fragment>
        {this.state.isLoading && <Loading />}
        <main className="pwd-change-container">
          <section className="card pwd-change-card">
            {this.state.showPasswordUpdatedRecently && (
              <>
                <MessageBar
                  messageBarType={MessageBarType.warning}
                  // dismissButtonAriaLabel="Close"
                  // onDismiss={() => {
                  //   this.setState({ showPasswordUpdatedRecently: false });
                  // }}
                  isMultiline={true}
                >
                  You have changed your password recently. Please try after 24
                  hours.
                </MessageBar>
                <br />
              </>
            )}
            <Formik
              initialValues={this.state.updatePassword}
              validate={(values) => {
                let errors: FormikErrors<IUpdatePassword> = {};
                if (!values.oldPassword) {
                  errors.oldPassword = "Required";
                }
                if (!values.newPassword) {
                  errors.newPassword = "Required";
                }
                if (
                  values.newPassword &&
                  !isValidPassword(values.newPassword)
                ) {
                  errors.newPassword = "Please enter valid password.";
                }
                if (!values.confirmPassword) {
                  errors.confirmPassword = "Required";
                }
                if (
                  values.newPassword &&
                  values.confirmPassword &&
                  values.newPassword !== values.confirmPassword
                ) {
                  errors.confirmPassword = "Password does not match";
                }
                return errors;
              }}
              onSubmit={async (
                values: IUpdatePassword,
                { setSubmitting, setFieldValue }
              ) => {
                this.setState({ isLoading: true });
                let result;
                if (this.state.isAdmin) {
                  result = await updateAdminPassword(values);
                } else {
                  result = await updateTeamRolePassword(values);
                }
                if (result && result.success) {
                  this.props.showToast(
                    "Password Updated Successfully",
                    "success"
                  );
                  this.props.history.push("/");
                } else {
                  if (
                    result.message &&
                    result.message.includes("Please use different password")
                  ) {
                    this.setState({
                      errorMsg:
                        "Sorry, but this password has already been used. Please create another.",
                    });
                    setFieldValue("newPassword", "");
                    setFieldValue("confirmPassword", "");
                  } else this.props.showToast(result.message, "error");
                }
                this.setState({ isLoading: false });
                setSubmitting(false);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <Label className="login-label">Current Password</Label>
                  <TextField
                    id="oldPassword"
                    name="oldPassword"
                    // label='Current Password'
                    autoComplete="current-password"
                    autoFocus
                    type="password"
                    onChange={handleChange}
                    errorMessage={
                      errors.oldPassword && touched.oldPassword
                        ? errors.oldPassword
                        : ""
                    }
                    onBlur={handleBlur}
                    value={values.oldPassword}
                    disabled={this.state.showPasswordUpdatedRecently}
                    underlined
                  />
                  <Label className="login-label">New Password</Label>
                  <TextField
                    id="newPassword"
                    name="newPassword"
                    // label="New Password"
                    autoComplete="new-password"
                    type="password"
                    onChange={handleChange}
                    errorMessage={
                      errors.newPassword && touched.newPassword
                        ? errors.newPassword
                        : ""
                    }
                    onBlur={handleBlur}
                    value={values.newPassword}
                    disabled={this.state.showPasswordUpdatedRecently}
                    underlined
                  />
                  {errors.newPassword &&
                    touched.newPassword &&
                    values.newPassword && (
                      <PasswordPolicy password={values.newPassword} />
                    )}
                  <Label className="login-label">Confirm Password</Label>
                  <TextField
                    id="confirmPassword"
                    name="confirmPassword"
                    // label="Confirm Password"
                    autoComplete="confirm-password"
                    type="password"
                    onChange={handleChange}
                    errorMessage={
                      errors.confirmPassword && touched.confirmPassword
                        ? errors.confirmPassword
                        : ""
                    }
                    onBlur={handleBlur}
                    value={values.confirmPassword}
                    disabled={this.state.showPasswordUpdatedRecently}
                    underlined
                  />
                  <br />
                  {this.state.errorMsg && (
                    <>
                      <MessageBar
                        messageBarType={MessageBarType.error}
                        dismissButtonAriaLabel="Close"
                        onDismiss={() => {
                          this.setState({ errorMsg: "" });
                        }}
                        isMultiline={true}
                      >
                        {this.state.errorMsg}
                      </MessageBar>
                      <br />
                    </>
                  )}
                  <PrimaryButton
                    type="submit"
                    // color="primary"
                    disabled={isSubmitting}
                    className="login-btn"
                  >
                    Update Password
                  </PrimaryButton>
                </form>
              )}
            </Formik>
          </section>
        </main>
      </React.Fragment>
    );
  }
}

export default withToastContext(withRouter(ChangePasswordPage));
